import React from 'react';
import { Redirect } from 'react-router-dom';
import { MENUS } from './layout/menus';
import { useAuthz, useMe } from '../store';
import { allows } from '../api/authz';

/**
 * 首页落地 (2026-09-12): 普通用户默认不再可读全部业务数据, 写死跳 /materials 会直接落到「无权访问」.
 * 按侧栏同一口径 (menus.ts 的 resource/verb) 找第一个看得到的菜单跳过去; 什么都没有就去「我的工单」.
 */
const HomeRedirect = () => {
    const authz = useAuthz();
    const me = useMe();
    if (!authz.loaded || !me.loaded) return null;
    const canSee = (resource?: string, verb = 'get') =>
        !resource || allows(authz.rules, resource, verb);
    const first = MENUS.find(
        (m) =>
            (!m.replicaOnly || me.siteRole === 'replica') &&
            !m.nonAdminOnly &&
            canSee(m.resource, m.verb) &&
            m.subs.some((s) => canSee(s.resource, s.verb)),
    );
    const target = first
        ? first.subs.find((s) => canSee(s.resource, s.verb))?.path || first.path
        : '/my-approvals';
    return <Redirect to={target} />;
};

export default HomeRedirect;
